module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEySURBVHgB7ZMxbsIwFIYds3RKnAtEHjumG2O6MbZjN3qDcoK2N2CDDbGxwQZMwA1yhBzB2ZgS/ifZyLISMGygPMky/La/z3Ecxrp6+gp8JyZJ8ovuB01xzt8LlM86L4GG/1lR4Su5KmiAmzJPkrN7BYDP0A0vzYFkCMm8bbx3CxywEboXNGmyuq4/oihiZVkevARSShGG4aQB/o2dTgGaAxgj6lvDWZuk58Krqtrh58BkQRDQWX8BvjAZQBsA6XgzRyIwtm0UWPDUhqPRi9y7OwNo3yDpCyHSOI63SqnjWQC4BHzdAm+9JSQBrMR7GFjxK/3XEsUpAXzpwAu0t2tXkApzxjjCT9qQFaeQ0CVhXAOlA/f+UrVkRWtorckgyGzBv87zW+GWJDcS/TQj1lVXj1EnXfWR2a1lhoIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_top2.png
// module id = aszR
// module chunks = 1